import { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../lib/cn';

/**
 * Gestyltes natives <select> — gleiche Optik wie das nova-Input (§6.2),
 * eigener Chevron statt Browser-Pfeil. Bewusst nativ (statt Radix-Select),
 * damit Formular-Logik (`onChange`, react-hook-form `register`) unverändert
 * bleibt. Layout-Klassen (Breite) gehören auf `className` (Wrapper).
 */
export interface SelectNativeProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  /**
   * sm = 28 px (Inline-Tabellenzeilen), md = 32 px (Formulare/Toolbars, nova-Maß),
   * lg = 44 px (Tippziel für Touch — Baustelle/Lager auf dem iPad).
   */
  fieldSize?: 'sm' | 'md' | 'lg';
  hasError?: boolean;
}

export const SelectNative = forwardRef<HTMLSelectElement, SelectNativeProps>(
  ({ className, fieldSize = 'md', hasError, children, ...props }, ref) => (
    <span className={cn('relative inline-flex', className)}>
      <select
        ref={ref}
        aria-invalid={hasError || props['aria-invalid']}
        className={cn(
          'w-full appearance-none rounded-lg border border-input bg-transparent pr-8 text-sm text-foreground ' +
            'transition-colors outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 ' +
            'disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 ' +
            'aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20',
          { sm: 'h-7 pl-2', md: 'h-8 pl-2.5', lg: 'h-11 pl-3' }[fieldSize],
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        className="pointer-events-none absolute right-2 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
        strokeWidth={1.5}
        aria-hidden
      />
    </span>
  ),
);
SelectNative.displayName = 'SelectNative';
